import moment from "jalali-moment";

export default function jalaliDate(dateString, hasTime = false) {
    try {
        const date = dateParse(dateString);
        if (date) {
            if (hasTime) {
                return moment(date).locale('fa')
                    .format('YYYY/M/D   HH:mm');
            } else {
                return moment(date).locale('fa')
                    .format('YYYY/M/D');
            }
        } else return null;
    } catch (e) {
        return null
    }
}

const dateParse = (dateString) => {
    let matches = dateString.match(/^([\d]+)-([\d]+)-([\d]+)T([\d]+):([\d]+):([\d]+)\.[\d]+Z$/);
    if (!matches)
        matches = dateString.match(/^([\d]+)-([\d]+)-([\d]+) ([\d]+):([\d]+):([\d]+)$/);
    if (matches)
        return new Date(new Date(matches[1], matches[2] - 1, matches[3], matches[4], matches[5], matches[6]).toLocaleString('en-US', {timeZone: 'Asia/Tehran'}) + '+00:00');
    return null;
}
